import P6CriticalSummary from '../../lib/jin/svgchartlib/09_Projects/China1/03_Planning/P6/CriticalSummary/index.vue'

export default {
  P6CriticalSummary,
}
